import React from 'react';
import { translate } from '@utils/i18n';
import { Tag } from '@ui/atoms/Tag';
import ActionButtons from './components/ActionButtons';
// Cell components for grid columns
const badgeNamespace = 'features.ai_to_review_inspections.index.columns';
// IPA peer-job priority rating badge. Color is paired with text so the
// signal does not rely on color alone (WCAG 1.4.1).
const PRIORITY_VARIANT = {
    high_priority: 'red',
    medium_priority: 'yellow',
    low_priority: 'green'
};
export function PriorityCell({ dataItem }) {
    var _a;
    const rating = dataItem.priorityRating;
    if (!rating)
        return React.createElement("td", null, "\u2014");
    return (React.createElement("td", { className: "ia-review-badge-cell" },
        React.createElement(Tag, { label: translate(`risk_rating.${rating}`, { namespace: badgeNamespace, defaultValue: rating }), variant: (_a = PRIORITY_VARIANT[rating]) !== null && _a !== void 0 ? _a : 'gray', colorStyle: "solid", readOnly: true })));
}
export function InspectionIdCell({ dataItem }) {
    return (React.createElement("td", null,
        React.createElement("a", { href: `/inspections/${dataItem.inspectionId}#iim-issues`, target: "_blank", rel: "noopener noreferrer" }, dataItem.inspectionId)));
}
export function BuildingCell({ dataItem }) {
    return (React.createElement("td", null,
        React.createElement("a", { href: `/buildings/${dataItem.buildingId}`, target: "_blank", rel: "noopener noreferrer" }, dataItem.building)));
}
export function InspectionStatusCell({ dataItem }) {
    const { inspectionStatusLabel, inspectionStatusIcon, inspectionStatusColor } = dataItem;
    if (!inspectionStatusLabel)
        return React.createElement("td", null);
    return (React.createElement("td", { style: { whiteSpace: 'nowrap' } },
        React.createElement("i", { className: `fa-lg ${inspectionStatusIcon}`, style: { color: inspectionStatusColor !== null && inspectionStatusColor !== void 0 ? inspectionStatusColor : undefined } }),
        "\u00A0",
        inspectionStatusLabel));
}
export function ActionsCell({ dataItem }) {
    return (React.createElement("td", null,
        React.createElement(ActionButtons, { inspection: dataItem })));
}
